;(function (module) {
  'use strict'
  module.controller('SideBarController', [
    '$rootScope',
    '$scope',
    '$q',
    'alertService',
    'authService',
    'organizations',
    'members',
    function (
      $rootScope,
      $scope,
      $q,
      alertService,
      authService,
      organizations,
      members,
    ) {
      $scope.handledSmsData = []
      var vm = this
      //console.log('metisMenu called');
      //$('#sidebar').css('min-height', '100%');
      //$('#side-menu').metisMenu();

      vm.smsHandles = []
      vm.phoneHandles = []

      //init of page
      function updateCurrentHandles() {
        alertService.getHandledSms().then(function (response) {
          if (response.data) {
            vm.smsHandles = response.data
            vm.smsHandles.forEach(async function (sms, index) {
              await members.getMemberById(sms.TravelerId).then((res) => {
                vm.smsHandles[index]['travelerFirstName'] = res.data.FirstName
                vm.smsHandles[index]['travelerLastName'] = res.data.LastName
                vm.smsHandles[index]['travelerOrganizationName'] =
                  res.data.Organization.Name
                vm.smsHandles[index]['channel'] = 'sms'
              })
            })
            // console.log('smsHandles, 19', data)
            // console.log(vm.smsHandles)
            // var handledSms = response.data
            // vm.smsHandles = handledSms
          }
        })
      }

      const logInUser = authService.getLoginMember()
      if (logInUser) {
        $scope.organizationId = logInUser.Organization.Id
        $scope.organizationName = logInUser.Organization.Name
        $scope.firstName = logInUser.FirstName
        $scope.lastName = logInUser.LastName
        $scope.logInUserRole = logInUser.Role
        if (logInUser.Role == 4) {
          //$scope.introOptions.steps[0].intro = "Select an agency and then a client to begin.";
        }
      } else {
        $scope.organizationName = ''
        $scope.firstName = ''
        $scope.lastName = ''
      }
      const loginOrganizationPromise = organizations.getOrganizationById(
        $scope.organizationId,
      )
      $q.all([loginOrganizationPromise]).then(function (response) {
        $scope.LogoImageLink = response[0].data.LogoImageLink
        updateCurrentHandles()
      })

      $scope.$on('clientChangeEvent', function (event, data) {
        $scope.allowOpenBookings = data.allowOpenBookings
      })

      $scope.$on('removeFinishSms', function (event, data) {
        const dataBookingId = data.topic && data.topic.bookingId ? data.topic.bookingId : null;

        const tempSmsHandles = vm.smsHandles.filter(smsHandle => {
          const bookingId = (smsHandle.Topic && smsHandle.Topic.BookingId) ? smsHandle.Topic.BookingId : (smsHandle.topic && smsHandle.topic.bookingId) ? smsHandle.topic.bookingId : null
          const travelerId = (smsHandle.TravelerId) ? smsHandle.TravelerId : smsHandle.travelerId
          return (( dataBookingId && bookingId && dataBookingId !== bookingId && data.travelerId !== travelerId) || (data.travelerId !== travelerId))
        })
        vm.smsHandles = tempSmsHandles
       })

      //on socket event
      $scope.$on('smsHandle', function (event, data) {
        /* data = {
          fromNumber,
          socketId,
          travelAgencyId,
          travelAgencyName,
          travelAgentFirstName,
          travelAgentLastName,
          travelAgentEmail,
          topic,
          travelerFirstName,
          travelerLastName,
          travelerOrganizationName,
        } */
        vm.smsHandles.push(data)
      })

      $scope.$on('phoneHandle', function (event, data) {
        /* data = {
          fromNumber,
          socketId,
          travelAgencyId,
          travelAgencyName,
          travelAgentFirstName,
          travelAgentLastName,
          travelAgentEmail,
          topic,
          travelerFirstName,
          travelerLastName,
          travelerOrganizationName,
        } */
        vm.phoneHandles.push(data)
      })
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/sideBarController.js